module.exports = __webpack_public_path__ + "static/media/frontline-12-team.47831526.png";